/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { Container, UnorderedList, UnorderedListItem, useTheme } from "@carrotfertility/carotene-core"
import React from "react"
import { MessageDescriptor, defineMessage, useIntl } from "react-intl"

function StyledListItem({ message }: { message: MessageDescriptor }): JSX.Element {
  const intl = useIntl()
  const { tokens } = useTheme()
  return (
    <UnorderedListItem sx={{ marginBottom: tokens.spacing.xs, marginTop: tokens.spacing.xs, lineHeight: 1.5 }}>
      {intl.formatMessage(message)}
    </UnorderedListItem>
  )
}

export default function AppointmentRequirements(): JSX.Element {
  const { tokens } = useTheme()
  return (
    <Container>
      <UnorderedList sx={{ marginLeft: tokens.spacing.md }}>
        <StyledListItem message={defineMessage({ defaultMessage: "Preferred appointment times" })} />
        <StyledListItem message={defineMessage({ defaultMessage: "Your phone number" })} />
        <StyledListItem message={defineMessage({ defaultMessage: "Preferred contact method (phone or email)" })} />
        <StyledListItem
          message={defineMessage({
            defaultMessage: "Type of care (Is there a specific service or treatment you have in mind?)"
          })}
        />
        <StyledListItem
          message={defineMessage({
            defaultMessage:
              "Are you bringing a partner? If you are bringing a partner, please provide information about partner."
          })}
        />
        <UnorderedList
          sx={{ paddingTop: tokens.spacing.none, paddingBottom: tokens.spacing.none, paddingLeft: tokens.spacing.xxl }}
        >
          <StyledListItem message={defineMessage({ defaultMessage: "Name" })} />
          <StyledListItem message={defineMessage({ defaultMessage: "Date of Birth" })} />
          <StyledListItem message={defineMessage({ defaultMessage: "Address" })} />
          <StyledListItem message={defineMessage({ defaultMessage: "Phone Number" })} />
          <StyledListItem message={defineMessage({ defaultMessage: "Email address" })} />
          <StyledListItem message={defineMessage({ defaultMessage: "Preferred contact method (phone or email)" })} />
        </UnorderedList>
        <StyledListItem
          message={defineMessage({
            defaultMessage:
              "Are there any other questions or concerns you would like us to tell the provider when setting up your appointment?"
          })}
        />
      </UnorderedList>
    </Container>
  )
}
